import React from 'react';

import { StyleSheet, View } from 'react-native';

import { t } from 'state/intl/translations';

import { InnerHeader } from '../styled';
import type { RestaurantDetailItem } from '../types';

import { AmenityItems } from './amenity-items';

interface AmenitiesSectionProps {
  items: RestaurantDetailItem[];
}

export const AmenitiesSection = ({ items }: AmenitiesSectionProps) => (
  <View testID="restaurant-amenities" style={styles.amenitiesSection}>
    <InnerHeader
      accessibilityLevel={2}
      variant="headerThree"
      testID="in-store-amenities"
      style={styles.sectionHeading}
    >
      {t('inStoreAmenities', 'Amenities')}
    </InnerHeader>
    <AmenityItems items={items} />
  </View>
);

const styles = StyleSheet.create({
  amenitiesSection: {
    paddingHorizontal: 24,
    paddingTop: 14,
    paddingBottom: 16,
  },
  sectionHeading: {
    marginBottom: 0,
  },
});
